var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c("div", [
        _c(
          "form",
          {
            ref: "updateHotelForm",
            attrs: { novalidate: "", disabled: _vm.disabled },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return (() => {}).apply(null, arguments)
              },
            },
          },
          [
            _c(
              "v-row",
              { attrs: { "no-gutters": "" } },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "8" } },
                  [
                    _c(
                      "v-card",
                      {
                        attrs: {
                          "max-width": "1200",
                          flat: "",
                          color: "transparent",
                        },
                      },
                      [
                        _c(
                          "v-card-title",
                          { staticClass: "mb-10" },
                          [
                            _c("FormHeader", {
                              attrs: {
                                loading: _vm.loading,
                                disabled: _vm.disabled,
                                link: "page-hotels",
                                title: _vm.data.title
                                  ? `${_vm.data.title} отель`
                                  : `Создать отель`,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          [
                            _c(
                              "v-container",
                              [
                                _c("HeaderSteppers", {
                                  attrs: {
                                    tabs: _vm.$options.tabsNav,
                                    "is-new": _vm.isNew,
                                    rules: _vm.getRulesTab,
                                    tooltipMessages:
                                      "Необходимо создать отель!",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "0",
                                      fn: function () {
                                        return [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "PageContent",
                                                { attrs: { height: "65" } },
                                                [
                                                  _c("InputTitleSlug", {
                                                    attrs: {
                                                      "is-loading":
                                                        _vm.loading ||
                                                        _vm.disabled,
                                                      title: _vm.fields.title,
                                                      "title-error":
                                                        _vm.getFieldErrorMessage(
                                                          "title"
                                                        ),
                                                      slug: _vm.fields.slug,
                                                      "slug-error":
                                                        _vm.getFieldErrorMessage(
                                                          "slug"
                                                        ),
                                                      isSlugEnabled: !_vm.isNew,
                                                    },
                                                    on: {
                                                      "change:title": function (
                                                        $event
                                                      ) {
                                                        _vm.fields.title =
                                                          $event
                                                      },
                                                      "change:slug": function (
                                                        $event
                                                      ) {
                                                        _vm.fields.slug = $event
                                                      },
                                                      "input:slug":
                                                        _vm.$v.fields.slug
                                                          .$touch,
                                                    },
                                                  }),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c(
                                                            "MediaFilePicker",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Миниатюра",
                                                                multiple: false,
                                                                "file-type":
                                                                  _vm.$options
                                                                    .mediaTypesByKeys
                                                                    .IMAGE,
                                                                value:
                                                                  _vm.fields
                                                                    .thumbnailId,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.fields.thumbnailId =
                                                                      $event
                                                                  },
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c(
                                                            "MediaFilePicker",
                                                            {
                                                              attrs: {
                                                                id: "images",
                                                                label:
                                                                  "Изображения*",
                                                                "file-type":
                                                                  _vm.$options
                                                                    .mediaTypesByKeys
                                                                    .IMAGE,
                                                                value:
                                                                  _vm.fields
                                                                    .images,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.fields.images =
                                                                      $event
                                                                  },
                                                              },
                                                            }
                                                          ),
                                                          _c("ErrorMessage", {
                                                            attrs: {
                                                              message:
                                                                _vm.getFieldErrorMessage(
                                                                  "images"
                                                                ),
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v("Адрес*"),
                                                          ]),
                                                          _c(
                                                            "LocationAutocomplete",
                                                            {
                                                              attrs: {
                                                                id: "address",
                                                                address:
                                                                  _vm.fields
                                                                    .address,
                                                                loading:
                                                                  _vm.loading ||
                                                                  _vm.disabled,
                                                                "error-messages":
                                                                  _vm.getFieldErrorMessage(
                                                                    "address"
                                                                  ),
                                                              },
                                                              on: {
                                                                "set-location":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.fields.address =
                                                                      $event
                                                                  },
                                                                "update-location-part":
                                                                  _vm.updateLocation,
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            [
                                                              _vm._v(
                                                                "Описание* ("
                                                              ),
                                                              _c(
                                                                "TranslationIcon"
                                                              ),
                                                              _vm._v(")"),
                                                            ],
                                                            1
                                                          ),
                                                          _c("QuillEditorVue", {
                                                            attrs: {
                                                              id: "description",
                                                              cols: 12,
                                                              title: "",
                                                              loading:
                                                                _vm.loading,
                                                              disabled:
                                                                _vm.disabled,
                                                              isShowErrorMessage: true,
                                                              errorText:
                                                                _vm.getFieldErrorMessage(
                                                                  "description"
                                                                ),
                                                              content:
                                                                _vm.fields
                                                                  .description,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                _vm.fields.description =
                                                                  $event
                                                              },
                                                              onChangeContent:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$emit(
                                                                    "change:descriptionForMobile",
                                                                    {
                                                                      fields:
                                                                        _vm.fields,
                                                                      $event,
                                                                    }
                                                                  )
                                                                },
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            [
                                                              _vm._v(
                                                                "Краткое описание* ("
                                                              ),
                                                              _c(
                                                                "TranslationIcon"
                                                              ),
                                                              _vm._v(")"),
                                                            ],
                                                            1
                                                          ),
                                                          _c("QuillEditorVue", {
                                                            attrs: {
                                                              id: "shortDescription",
                                                              loading:
                                                                _vm.loading,
                                                              disabled:
                                                                _vm.disabled,
                                                              cols: 12,
                                                              title: "",
                                                              isShowErrorMessage: true,
                                                              errorText:
                                                                _vm.getFieldErrorMessage(
                                                                  "shortDescription"
                                                                ),
                                                              content:
                                                                _vm.fields
                                                                  .shortDescription,
                                                              "light-mode": "",
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                _vm.fields.shortDescription =
                                                                  $event
                                                              },
                                                              onChangeContent:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$emit(
                                                                    "change:shortDescriptionForMobile",
                                                                    {
                                                                      fields:
                                                                        _vm.fields,
                                                                      $event,
                                                                    }
                                                                  )
                                                                },
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              "Количество звезд"
                                                            ),
                                                          ]),
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              outlined: "",
                                                              disabled:
                                                                _vm.disabled,
                                                              loading:
                                                                _vm.loading,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.fields
                                                                  .stars,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.fields,
                                                                    "stars",
                                                                    _vm._n($$v)
                                                                  )
                                                                },
                                                              expression:
                                                                "fields.stars",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c("SeoSettings", {
                                                            attrs: {
                                                              data: _vm.data,
                                                              loading:
                                                                _vm.loading ||
                                                                _vm.disabled,
                                                            },
                                                            on: {
                                                              "on-input-seo":
                                                                function (
                                                                  $event
                                                                ) {
                                                                  _vm.fields =
                                                                    Object.assign(
                                                                      {},
                                                                      _vm.fields,
                                                                      $event
                                                                    )
                                                                },
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "6" },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              "Время заезда*"
                                                            ),
                                                          ]),
                                                          _c("TimePicker", {
                                                            attrs: {
                                                              id: "checkInTime",
                                                              step: "1",
                                                              loading:
                                                                _vm.loading,
                                                              disabled:
                                                                _vm.disabled,
                                                              "error-messages":
                                                                _vm.getFieldErrorMessage(
                                                                  "checkInTime"
                                                                ),
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.fields
                                                                  .checkInTime,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.fields,
                                                                    "checkInTime",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "fields.checkInTime",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "6" },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              "Время выезда*"
                                                            ),
                                                          ]),
                                                          _c("TimePicker", {
                                                            attrs: {
                                                              step: "1",
                                                              loading:
                                                                _vm.loading,
                                                              disabled:
                                                                _vm.disabled,
                                                              "error-messages":
                                                                _vm.getFieldErrorMessage(
                                                                  "checkOutTime"
                                                                ),
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.fields
                                                                  .checkOutTime,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.fields,
                                                                    "checkOutTime",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "fields.checkOutTime",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-card-actions",
                                                    [
                                                      _c("BtnNext", {
                                                        attrs: {
                                                          loading: _vm.loading,
                                                          disabled:
                                                            _vm.disabled,
                                                          title: `${
                                                            _vm.isNew
                                                              ? "Создать"
                                                              : "Сохранить"
                                                          } ${_vm.tabs[
                                                            _vm.activeTab
                                                          ].title.toLowerCase()}`,
                                                        },
                                                        on: {
                                                          nextClick: function (
                                                            $event
                                                          ) {
                                                            return _vm.nextBtnClickHandler(
                                                              _vm.activeTab
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "1",
                                      fn: function () {
                                        return [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "PageContent",
                                                { attrs: { height: "65" } },
                                                [
                                                  _c("FormHotelRoomTypes", {
                                                    attrs: {
                                                      "room-types":
                                                        _vm.fields.roomTypes ||
                                                        [],
                                                      amenities: _vm.amenities,
                                                      "error-messages":
                                                        _vm.$v.fields.roomTypes
                                                          .$each || {},
                                                      "is-valid-room-types":
                                                        _vm.$v.fields.roomTypes
                                                          .$dirty &&
                                                        _vm.$v.fields.roomTypes
                                                          .$invalid,
                                                    },
                                                    on: {
                                                      create:
                                                        _vm.createRoomType,
                                                      option:
                                                        _vm.roomTypeOptionHandler,
                                                      "change:descriptionForMobile":
                                                        function ($event) {
                                                          return _vm.changeDescriptionForMobileInRoomType(
                                                            $event
                                                          )
                                                        },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-card-actions",
                                            [
                                              _c("BtnNext", {
                                                attrs: {
                                                  loading: _vm.loading,
                                                  disabled: _vm.disabled,
                                                  title: `${
                                                    _vm.isNew
                                                      ? "Создать"
                                                      : "Сохранить"
                                                  } ${_vm.tabs[
                                                    _vm.activeTab
                                                  ].title.toLowerCase()}`,
                                                },
                                                on: {
                                                  nextClick: function ($event) {
                                                    return _vm.nextBtnClickHandler(
                                                      _vm.activeTab
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "2",
                                      fn: function () {
                                        return [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "PageContent",
                                                { attrs: { height: "65" } },
                                                [
                                                  _c("FormHotelRooms", {
                                                    attrs: {
                                                      rooms:
                                                        _vm.fields.rooms || [],
                                                      "room-types":
                                                        _vm.data.roomTypes ||
                                                        [],
                                                      "error-messages":
                                                        _vm.$v.fields.rooms
                                                          .$each || {},
                                                    },
                                                    on: {
                                                      create: _vm.createRoom,
                                                      option:
                                                        _vm.roomOptionHandler,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { attrs: { cols: "4" } },
                  [
                    _c("ManageSidePanel", {
                      attrs: {
                        isShowSortOrder: "",
                        "is-new": !_vm.data.id,
                        "created-at": _vm.data.createdAt,
                        "updated-at": _vm.data.updatedAt,
                        "published-at": _vm.data.publishedAt || "",
                        author: _vm.data.author,
                        "is-loading": _vm.loading,
                        "is-submit-disabled": _vm.disabled,
                        language: _vm.language,
                        translations: _vm.fields.translations,
                        "entity-id": _vm.data.id,
                        sortOrder: _vm.fields.sortOrder,
                        "entity-type": "hotel",
                      },
                      on: {
                        delete: function ($event) {
                          return _vm.$emit("delete-hotel")
                        },
                        cancel: function ($event) {
                          return _vm.$router.push({ name: "page-hotels" })
                        },
                        submit: _vm.submit,
                        "update-translations": function ($event) {
                          return Object.assign(_vm.fields.translations, $event)
                        },
                        "language-update": function ($event) {
                          return _vm.$emit("language-update", $event)
                        },
                        "update-sort-order": function ($event) {
                          _vm.fields.sortOrder = Number($event)
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "info-append",
                          fn: function () {
                            return [
                              _c(
                                "v-row",
                                { attrs: { align: "center" } },
                                [
                                  _c("v-col", { attrs: { cols: "6" } }, [
                                    _vm._v(" Резерваций: "),
                                  ]),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "page-orders-booking",
                                              query: { id: _vm.data.id },
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.reservationsCount) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("StatusPicker", {
                                attrs: {
                                  align: "center",
                                  cols: "12",
                                  title: "Статус:",
                                  disabled: _vm.disabled,
                                  loading: _vm.loading,
                                  status: _vm.fields.status,
                                },
                                on: {
                                  "status:change": function ($event) {
                                    _vm.fields.status = $event
                                  },
                                },
                              }),
                              !!_vm.fields.detailsEntityId
                                ? _c(
                                    "v-row",
                                    { attrs: { align: "center" } },
                                    [
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c("span", [
                                          _vm._v("Посмотреть инф. о партнере"),
                                        ]),
                                      ]),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                icon: "",
                                                color: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$refs.profileForm.open()
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v(
                                                  "mdi-card-account-details"
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !!_vm.fields.detailsEntityId
                                ? _c(
                                    "v-row",
                                    { attrs: { align: "center" } },
                                    [
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c("span", [
                                          _vm._v("Посмотреть общий доступ"),
                                        ]),
                                      ]),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                icon: "",
                                                link: "",
                                                color: "primary",
                                                to: _vm.redirectToSharedAccess,
                                                loading: _vm.loading,
                                                disabled: _vm.disabled,
                                              },
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("mdi-account-group"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-subtitle",
                                    { staticClass: "grey--text" },
                                    [_vm._v(" Связи ")]
                                  ),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("span", [_vm._v("Город*")]),
                                              _c("v-select", {
                                                attrs: {
                                                  id: "cityId",
                                                  chips: "",
                                                  disabled: _vm.disabled,
                                                  loading: _vm.loading,
                                                  "error-messages":
                                                    _vm.getFieldErrorMessage(
                                                      "cityId"
                                                    ),
                                                  outlined: "",
                                                  dense: "",
                                                  "item-value": "id",
                                                  "item-text": "title",
                                                  clearable: "",
                                                  items: _vm.cities,
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "selection",
                                                    fn: function ({ item }) {
                                                      return [
                                                        _c(
                                                          "v-chip",
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.title
                                                                ) +
                                                                " "
                                                            ),
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  icon: "",
                                                                  "x-small": "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      _vm.fields.cityId =
                                                                        null
                                                                      _vm.fields.placeId =
                                                                        null
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    " mdi-close "
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                                model: {
                                                  value: _vm.fields.cityId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.fields,
                                                      "cityId",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "fields.cityId",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("span", [_vm._v("Тип*")]),
                                              _c("v-select", {
                                                attrs: {
                                                  chips: "",
                                                  outlined: "",
                                                  dense: "",
                                                  id: "typeId",
                                                  "item-value": "id",
                                                  "item-text": "label",
                                                  clearable: "",
                                                  disabled: _vm.disabled,
                                                  loading: _vm.loading,
                                                  "error-messages":
                                                    _vm.getFieldErrorMessage(
                                                      "typeId"
                                                    ),
                                                  items: _vm.types,
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "selection",
                                                    fn: function ({ item }) {
                                                      return [
                                                        _c(
                                                          "v-chip",
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.label
                                                                ) +
                                                                " "
                                                            ),
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  icon: "",
                                                                  "x-small": "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      _vm.fields.typeId =
                                                                        null
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    " mdi-close "
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                                model: {
                                                  value: _vm.fields.typeId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.fields,
                                                      "typeId",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "fields.typeId",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.isCertificateNumberRequired
                                        ? _c(
                                            "v-row",
                                            { attrs: { "no-gutters": "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Номер сертификата*"
                                                    ),
                                                  ]),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      outlined: "",
                                                      dense: "",
                                                      id: "certificateNumber",
                                                      disabled: _vm.disabled,
                                                      loading: _vm.loading,
                                                      "error-messages":
                                                        _vm.getFieldErrorMessage(
                                                          "certificateNumber"
                                                        ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.fields
                                                          .certificateNumber,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "certificateNumber",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.certificateNumber",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-row",
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("span", [_vm._v("Удобства")]),
                                              _c("v-select", {
                                                attrs: {
                                                  chips: "",
                                                  disabled: _vm.disabled,
                                                  loading: _vm.loading,
                                                  outlined: "",
                                                  dense: "",
                                                  "item-value": "id",
                                                  "item-text": "label",
                                                  multiple: "",
                                                  items: _vm.facilities,
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "selection",
                                                    fn: function ({ item }) {
                                                      return [
                                                        _c("v-chip", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.label
                                                              ) +
                                                              " "
                                                          ),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                                model: {
                                                  value: _vm.fields.facilities,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.fields,
                                                      "facilities",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "fields.facilities",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.fields.detailsEntityId
              ? _c("ProfileForm", {
                  ref: "profileForm",
                  attrs: {
                    profileId: _vm.fields.detailsEntityId,
                    detailsEntityType: _vm.fields.detailsEntityType,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }